import Icon from '../components/Icon'

Icon.register({
  clock: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM348.5 321c2.2-2.7 3.5-6.2 3.5-10 0-5.1-2.4-9.6-6-12.5l-58-42.5v-144c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v155.6c0 12.6 5.8 23.9 15 31.2l67 49.7v0c2.7 2.2 6.2 3.5 10 3.5 5.1 0 9.6-2.4 12.5-6l20-25v0z'
      }
    ]
  }
})
